import { getCurrency } from 'helper/numberFormat';
import React from 'react';
import { ArrowButton, Input, InputCurrency, InputField, InputLabel, InputWrapper } from './Theme';
const NumberInput = ({
  value,
  onChange,
  label
}) => {
  const currency = getCurrency();


  const handleInputChange = (event) => {
    const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
    const value = event?.target?.value.match(regex)[0];
    onChange(value);

  };
  return (
    <InputWrapper>
      <InputField>
        <Input
          type="text"
          value={value}
          onChange={handleInputChange}
          placeholder={label}
        />
        <InputCurrency>
          {currency}
        </InputCurrency>
      </InputField>
    </InputWrapper>
  )
}

export default NumberInput